import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { ReportingPeriod } from '../reporting-period';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var DidNotPurchaseService = /** @class */ (function () {
    function DidNotPurchaseService(http) {
        this.http = http;
    }
    DidNotPurchaseService.prototype.CreateDidNotPurchaseReport = function (startDate, dealerId) {
        var url = "dealers/" + (dealerId ? dealerId : 'mine') + "/reports/" + startDate.getFullYear() + "/" + (startDate.getMonth() + 1) + "/" + startDate.getDate() + "/did-not-purchase/";
        return this.http.post(url, { headers: { 'Content-Type': 'application/json' } }).pipe(map(function (response) { return response ? ReportingPeriod.fromJSON(response) : null; }));
    };
    DidNotPurchaseService.ngInjectableDef = i0.defineInjectable({ factory: function DidNotPurchaseService_Factory() { return new DidNotPurchaseService(i0.inject(i1.HttpClient)); }, token: DidNotPurchaseService, providedIn: "root" });
    return DidNotPurchaseService;
}());
export { DidNotPurchaseService };
